import React from 'react';
import { CompanyDetails as CompanyDetailsType } from '../models/invoice';

interface Props {
    company: CompanyDetailsType;
    onChange: (field: string, value: string) => void;
    hiddenFields: { [key: string]: boolean };
    onToggleVisibility: (field: string) => void;
    companyLogo: string | null;
    setCompanyLogo: (logo: string | null) => void;
    onLogoUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClearLogo: () => void;
}

const CompanyDetails: React.FC<Props> = ({ company, onChange, hiddenFields, onToggleVisibility, companyLogo, setCompanyLogo, onLogoUpload, onClearLogo }) => {
    const handleInput = (field: keyof CompanyDetailsType, value: string) => {
        onChange(field, value);
    };

    return (
        <div>
            <div style={styles.logoUploadSection}>
                <div style={styles.logoPreview}>
                    {companyLogo ? (
                        <img src={companyLogo} alt="Company Logo" style={styles.uploadedLogoImg} />
                    ) : (
                        <span style={styles.noLogoText}>Nėra logotipo</span>
                    )}
                </div>
                <div style={styles.logoActions}>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={onLogoUpload}
                        style={{ display: 'none' }}
                        id="company-logo-upload"
                    />
                    <label htmlFor="company-logo-upload" style={styles.uploadButton}>
                        Įkelti logotipą
                    </label>
                    {companyLogo && (
                        <button onClick={onClearLogo} style={styles.clearButton}>
                            Išvalyti logotipą
                        </button>
                    )}
                </div>
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['name'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Pavadinimas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['name']}
                        onChange={() => onToggleVisibility('name')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={company.name}
                    onChange={(e) => handleInput('name', e.target.value)}
                    placeholder="Mano Įmonė UAB"
                    style={styles.input}
                    disabled={hiddenFields['name']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['address'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Adresas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['address']}
                        onChange={() => onToggleVisibility('address')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={company.address}
                    onChange={(e) => handleInput('address', e.target.value)}
                    placeholder="Gatvės g. 1, Vilnius"
                    style={styles.input}
                    disabled={hiddenFields['address']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['registrationCode'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Įmonės kodas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['registrationCode']}
                        onChange={() => onToggleVisibility('registrationCode')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={company.registrationCode}
                    onChange={(e) => handleInput('registrationCode', e.target.value)}
                    placeholder="123456789"
                    style={styles.input}
                    disabled={hiddenFields['registrationCode']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['vatCode'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    PVM kodas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['vatCode']}
                        onChange={() => onToggleVisibility('vatCode')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={company.vatCode}
                    onChange={(e) => handleInput('vatCode', e.target.value)}
                    placeholder="LT123456789"
                    style={styles.input}
                    disabled={hiddenFields['vatCode']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['bankName'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Bankas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['bankName']}
                        onChange={() => onToggleVisibility('bankName')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={company.bankName}
                    onChange={(e) => handleInput('bankName', e.target.value)}
                    placeholder="Swedbank"
                    style={styles.input}
                    disabled={hiddenFields['bankName']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['bankAccount'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Sąskaitos Nr.
                    <input
                        type="checkbox"
                        checked={!hiddenFields['bankAccount']}
                        onChange={() => onToggleVisibility('bankAccount')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={company.bankAccount}
                    onChange={(e) => handleInput('bankAccount', e.target.value)}
                    placeholder="LT00 0000 0000 0000 0000"
                    style={styles.input}
                    disabled={hiddenFields['bankAccount']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['swift'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    SWIFT
                    <input
                        type="checkbox"
                        checked={!hiddenFields['swift']}
                        onChange={() => onToggleVisibility('swift')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={company.swift}
                    onChange={(e) => handleInput('swift', e.target.value)}
                    placeholder="HABALT22"
                    style={styles.input}
                    disabled={hiddenFields['swift']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['email'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    El. paštas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['email']}
                        onChange={() => onToggleVisibility('email')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="email"
                    value={company.email}
                    onChange={(e) => handleInput('email', e.target.value)}
                    placeholder="info@imone.lt"
                    style={styles.input}
                    disabled={hiddenFields['email']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['phone'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Telefonas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['phone']}
                        onChange={() => onToggleVisibility('phone')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="tel"
                    value={company.phone}
                    onChange={(e) => handleInput('phone', e.target.value)}
                    placeholder="+370 600 00000"
                    style={styles.input}
                    disabled={hiddenFields['phone']}
                />
            </div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    formGroup: {
        marginBottom: '15px',
        position: 'relative', // For absolute positioning of toggle if needed
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '5px',
        fontWeight: 'bold',
        fontSize: '0.9rem',
        color: '#555',
    },
    input: {
        width: '100%',
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '1rem',
    },
    hiddenField: {
        opacity: 0.5,
        backgroundColor: '#f0f0f0',
        pointerEvents: 'none', // Disable interactions
    },
    visibilityToggle: {
        marginLeft: 'auto', // Push to the right
        marginRight: '5px',
        width: '16px',
        height: '16px',
        cursor: 'pointer',
        pointerEvents: 'all', // Re-enable interaction for the toggle itself
    },
    logoUploadSection: {
        marginBottom: '20px',
        paddingBottom: '20px',
        borderBottom: '1px solid #eee',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
    },
    logoPreview: {
        width: '100px',
        height: '100px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundColor: '#f9fafb',
    },
    uploadedLogoImg: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
    noLogoText: {
        color: '#888',
        fontSize: '0.8rem',
        textAlign: 'center',
    },
    logoActions: {
        display: 'flex',
        gap: '10px',
    },
    uploadButton: {
        backgroundColor: '#0056b3',
        color: 'white',
        border: 'none',
        padding: '8px 15px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '0.9rem',
        fontWeight: 'bold',
    },
    clearButton: {
        backgroundColor: '#dc3545',
        color: 'white',
        border: 'none',
        padding: '8px 15px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '0.9rem',
        fontWeight: 'bold',
    }
};

export default CompanyDetails;
